import React from "react"

export default function Partner({ logo, url, title, width, height }) {
  return (
    <a href={url} title={title} rel="noopener" className="">
      <img
        alt={title}
        src={logo}
        width={width}
        height={height}
        loading="lazy"
        className="max-h-24 w-full object-contain invert-20 dark:invert-90"
      />
    </a>
  )
}

// function PartnerPicture({ logoDark, logoLight, url, title }) {
//   return (
//     <a href={url} title={title} rel="noopener" className="opacity-85">
//       <picture>
//         <source srcSet={logoDark} media="(prefers-color-scheme: dark)" />
//         <img
//           alt={title}
//           src={logoLight}
//           width={154}
//           height={90}
//           className="max-h-24 w-full object-contain"
//         />
//       </picture>
//     </a>
//   )
// }
